import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";
export const HeaderVintageContainer = styled.div`
  height: 60px;
  overflow: hidden;
  background-color: white;
  ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.darkGrey};
      }
    }
  &.sticky {
    position: sticky;
    top: 0;
    animation: headAnimationSticky 0.7s ease-in-out;
    z-index: 100;
  }
  &.no-sticky {
    display: none;
  }

  .container-vintage {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 10px;
    padding: 10px 0;
    border: 1px solid ${Color.greySeparator};
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border: 1px solid ${ColorDark.greySeparator};
      }
    }

    ${breakpoints.phone} {
      height: 81px;
      padding-top: 6px;
    }
  }
  /* .date-header,
  .logo-header,
  .portada-header {
    width: calc(100% / 3);
    height: 98px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${breakpoints.phone} {
      width: 50%;
    }
  } */
  .date-header {
    align-items: flex-end;
    padding-right: 56px;
    padding-top: 12px;

    ${breakpoints.phone} {
      display: none;
    }
    p {
      ${Font.sansRegular}
      font-size:12px;
      line-height: 14px;
      color: black;
      width: 70%;
      text-align: right;

      &.date {
        color: ${Color.mainColor};
      }
    }
  }
  .logo-header {
    img {
      width: 135px;
      object-fit: contain;
      ${breakpoints.phone} {
        width: 130px;
      }
    }
  }
  .portada-header {
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 200px;
      height: 98px;
      object-position: top;
      z-index: 0;
      ${breakpoints.phone} {
        width: 100%;
        height: 81px;
      }
    }
  }

  @keyframes headAnimationSticky {
    0% {
      opacity: 0.3;
      transform: translateY(-100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
export const ModalTapa = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-content {
    position: relative;
    background: #000;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    display: inline-block;

    .btn-close {
      position: absolute;
      top: 8px;
      right: 4px;
      background: none;
      color: white;
      border: none;
      font-size: 20px;
      cursor: pointer;
      z-index: 10;

      :hover {
        opacity: 0.8;
      }

      .play-ico {
        filter: invert(1);
        ::before {
          content: "";
          display: block;
          background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDZMNiAxOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02IDZMMTggMTgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
          background-repeat: no-repeat;
          width: 24px;
          height: 24px;
        }
      }
    }
    img {
      display: block;
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100vh;
    }
  }
`;
